// extracted by mini-css-extract-plugin
export default {"hideYearNavigation":"Ikodbh4mlgn4BrAJuIsLoQ==","baseCalendar":"qqXdAewUEh-CgBehjaTGPg=="};